import { RiAddBoxLine } from "@itandi/itandi-bb-ui";
import { Button } from "@itandi/itandi-bb-ui/Button";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { useRouter } from "next/router";
import { useChatContext } from "~/context/ChatContext";
import { MEDIA_QUERY, useMediaQuery } from "~/hooks/useMediaQuery";
import type { DealConstructionContext } from "~/models/DealConstruction";
import { ConstructionDownloadButtons } from "./ConstructionDownloadButtons";
import Styles from "./ConstructionTop.module.scss";

type Props = {
	billingTarget: "owner" | "rentee" | null;
	constructionContext: DealConstructionContext;
	dealEstimationDraftHeader: DealConstructionContext | null;
	dealEstimationHistoryContext: DealConstructionContext | null;
	estimationAddDisabled: boolean;
	handleClickChangeAmount: (() => void) | null;
	handleClickCreateHeader: (() => void) | null;
	handleClickDestroyHeader: (() => void) | null;
	handleClickEstimationHistoryPreview: (() => void) | null;
	handleClickEstimationPreview: (() => void) | null;
	handleClickGenerateBillings: (() => void) | null;
	handleClickShowAddModal: (() => void) | null;
	ownManagement: boolean;
	readonly: boolean;
};

export function ConstructionActions({
	readonly,
	constructionContext,
	dealEstimationHistoryContext,
	dealEstimationDraftHeader,
	handleClickEstimationPreview,
	handleClickEstimationHistoryPreview,
	handleClickShowAddModal,
	handleClickChangeAmount,
	handleClickGenerateBillings,
	handleClickCreateHeader,
	handleClickDestroyHeader,
	billingTarget,
	estimationAddDisabled,
	ownManagement
}: Props) {
	const { isChatOpen } = useChatContext();
	const { match: isSp, isLoaded: windowLoaded } = useMediaQuery(MEDIA_QUERY.sp);
	const router = useRouter();
	const { id = null } = router.query;
	if (!windowLoaded || typeof id !== "string") return null;

	return (
		<Flex
			direction={isSp || isChatOpen ? "column" : "row"}
			gap="8px"
			marginLeft="auto"
			paddingX="8px"
			width={isSp ? "100%" : "auto"}
		>
			{handleClickChangeAmount !== null && (
				<Button
					onClick={handleClickChangeAmount}
					variant="tertiary"
					width={isSp ? "fill" : "default"}
				>
					施工単価一括変更
				</Button>
			)}
			{handleClickGenerateBillings ? (
				<Button
					onClick={handleClickGenerateBillings}
					variant="tertiary"
					width="default"
				>
					請求再作成
				</Button>
			) : null}
			{handleClickCreateHeader !== null && (
				<Button
					disabled={
						dealEstimationHistoryContext !== null &&
						dealEstimationHistoryContext.dealConstructions.length !== 0
					}
					onClick={handleClickCreateHeader}
					variant="tertiary"
					width={isSp ? "fill" : "default"}
				>
					棄却された見積りを復元
				</Button>
			)}
			{billingTarget === null &&
			dealEstimationDraftHeader &&
			handleClickDestroyHeader &&
			!ownManagement ? (
				<Button
					disabled={dealEstimationDraftHeader.dealConstructions.length === 0}
					onClick={handleClickDestroyHeader}
					variant="tertiary"
					width={isSp ? "fill" : "default"}
				>
					見積りを元に戻す
				</Button>
			) : null}
			<ConstructionDownloadButtons
				constructionContext={constructionContext}
				dealEstimationDraftHeader={dealEstimationDraftHeader}
				dealEstimationHistoryContext={dealEstimationHistoryContext}
				handleClickEstimationHistoryPreview={
					handleClickEstimationHistoryPreview
				}
				handleClickEstimationPreview={handleClickEstimationPreview}
				ownManagement={ownManagement}
			/>
			{handleClickShowAddModal !== null && !readonly && (
				<div className={Styles.AddButton}>
					<Button
						disabled={estimationAddDisabled}
						onClick={handleClickShowAddModal}
						startIcon={<RiAddBoxLine />}
						variant="secondary"
						width={isSp ? "fill" : "default"}
					>
						項目追加
					</Button>
				</div>
			)}
		</Flex>
	);
}
